var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 0.75,
    width: 21.9909,
    height: 29.4091,
    rx: 1.25,
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.90918,
    x2: 2,
    y2: 4.90918,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 9.90918,
    x2: 2,
    y2: 9.90918,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14.9092,
    x2: 2,
    y2: 14.9092,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 19.9092,
    x2: 2,
    y2: 19.9092,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 24.9092,
    x2: 2,
    y2: 24.9092,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.679,
    y1: 21.6034,
    x2: 14.847,
    y2: 22.6281,
    stroke: "#A3A3A3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 12.7549,
    y1: 23.404,
    x2: 14.2789,
    y2: 23.7073,
    stroke: "#A3A3A3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 13.4827,
    y1: 25.7027,
    x2: 14.754,
    y2: 24.8093,
    stroke: "#A3A3A3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9939 15.7252C32.1887 15.5277 32.1855 15.2094 31.9868 15.0159L26.7357 9.90213C26.5379 9.70948 26.2213 9.71367 26.0287 9.9115L16.1329 20.073C15.5447 20.677 15.5697 21.647 16.1881 22.2199L18.3097 24.1852C18.8158 24.6541 19.4932 24.8929 20.1814 24.8452L22.2606 24.7012C22.8683 24.6591 23.4398 24.3966 23.8676 23.9629L31.9939 15.7252Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.748 21.4695L20.001 17",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFile);
export default __webpack_public_path__ + "static/media/edit-file.79468ae90492820c4c1a135cbc7b7a34.svg";
export { ForwardRef as ReactComponent };